import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { LocalStorageItems } from '@core/models/storage.models';
import { UserStateService } from '@core/services/user-state.service';
import { BROWSER_STORAGE } from '@shared/tokens/browser.tokens';
import { UrlUtils } from '@shared/utils/url.util';
import { map, tap } from 'rxjs/operators';
import { appRoutesConfig } from 'src/app/app-routes.config';

export const authGuard: CanActivateFn = (_route, state) => {
	const userStateService = inject(UserStateService);
	const router = inject(Router);
	const storage = inject(BROWSER_STORAGE);

	return userStateService.userData$.pipe(
		map(({ isSignedIn }) => isSignedIn),
		tap(isSigned => {
			if (!isSigned) {
				if (UrlUtils.isSafeRedirectPath(state.url)) storage.setItem(LocalStorageItems.RedirectAfterLoginUrl, state.url);
				void router.navigate([appRoutesConfig.login.url]);
			} else {
				storage.removeItem(LocalStorageItems.RedirectAfterLoginUrl);
			}
		})
	);
};
